import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/node/Divider/index.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/src/components/layout/base/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/sitemap/PageFrame.tsx")